<div #screen style="height: 100vh">
  <!-- Global branded loader shown during route transitions (lazy-chunk loads)
       so there is no white blank screen between routes. -->
  <div *ngIf="isNavigating" class="app-nav-loader d-flex flex-column align-items-center justify-content-center gap-24px">
    <img src="assets/images/logo/xoopah-logo.svg" alt="Xoopah" class="app-nav-loader__logo" width="160" height="40" fetchpriority="high" />
    <mat-spinner class="btn-loader brandcolor-loader"></mat-spinner>
  </div>

  <router-outlet></router-outlet>

  <div *ngIf="isCalendlyPopupOpen" class="calendly-overlay" (click)="closeCalendlyPopup()">
    <div class="calendly-modal" (click)="$event.stopPropagation()">
      <button class="calendly-close-btn" type="button" (click)="closeCalendlyPopup()">
        <i-tabler name="x" class="main-icon main-icon-20px icon-icon-neutral-strong"></i-tabler>
      </button>
      <div id="calendly-embed" class="calendly-embed"></div>
    </div>
  </div>
  <!-- Support-screenshot overlay. @defer keeps ngx-capture + html2canvas fully on-demand:
       the chunk is fetched only when a capture is actually triggered (isCaptureScreen).
       No prefetch, so NO user downloads it unless they use the feature — guests (who can't
       trigger it) never load it at all. The chunk is small, so the first-capture fetch is
       quick; the inner d-none preserves the original show/hide behaviour. -->
  @defer (when contactSupportService.isCaptureScreen) {
    <div [ngClass]="{ 'd-none': !this.contactSupportService.isCaptureScreen }">
      <app-support-capture
        [target]="screen"
        [overlayUpdated]="!this.contactSupportService.isCaptureScreen"
        (resultImage)="saveImage($event)"
      ></app-support-capture>
    </div>
  }
</div>

<!-- Toast Container for Multiple Toasts -->
<div #toastContainer class="ugc-toast-container-wrapper"></div>

<div *ngIf="shopifyEmbeddedService.bootstrapError" class="shopify-bootstrap-error d-flex align-items-center justify-content-center">
  <div class="alert alert-error border-radius-lg">
    <div class="alert-content">
      <p class="body-md font-weight-semibold text-text-neutral-strong">Xoopah could not connect to Shopify</p>
      <p class="body-sm text-text-neutral-weak">{{ shopifyEmbeddedService.bootstrapError }}</p>
    </div>
  </div>
</div>
